query DashboardData($days: Int!, $days2n: Int!, $customFieldsFilter: ConditionStringArray, $customFieldsFilterExcludes: ConditionStringArray) {
  wsdkIssuesCount: wsdk_test_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: run_time_truncDay
  ) {
    run_time_truncDay
    critical_issues_sum
    serious_issues_sum
    total_issues_sum
  }
  
  wsdkIssuesCount2n: wsdk_test_runs(
    run_time_last_n_days: { value: [$days2n] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: run_time_truncDay
  ) {
    run_time_truncDay
    critical_issues_sum
    serious_issues_sum
    total_issues_sum
  }

  wfaIssuesCount: wfa_session_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: run_time_truncDay
  ) {
    run_time_truncDay
    critical_issues_sum
    serious_issues_sum
    total_issues_sum
  }
  
  wfaIssuesCount2n: wfa_session_runs(
    run_time_last_n_days: { value: [$days2n] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: run_time_truncDay
  ) {
    run_time_truncDay
    critical_issues_sum
    serious_issues_sum
    total_issues_sum
  }
}
